import { 
  LOAD_ACCESS_CODE_DATA_IN_PROGRESS,
  LOAD_ACCESS_CODE_DATA_SUCCESS,
  LOAD_ACCESS_CODE_DATA_FAILURE,
  ACCESS_CODE_CREATION_COMPLETED,
  OPEN_ACCESS_CODE_DIALOG,
  CLOSE_ACCESS_CODE_DIALOG,
  LOAD_ACCESS_CODE_LOGIN_USERNAME_SUCCESS,
  LOAD_ACCESS_CODE_LOGIN_USERNAME_CLEAR
} from "./actions";

const initialState = { isLoading: false, accessCodeList: [],isAccessCodeDialogOpen:false,loginUserName:'' };

export const accessCodeData= (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    
    case LOAD_ACCESS_CODE_DATA_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        accessCodeList: data,
      };
    }
    case LOAD_ACCESS_CODE_DATA_IN_PROGRESS:
    return {
      ...state,
      isLoading: true,
    };
    case LOAD_ACCESS_CODE_DATA_FAILURE:
    return {
      ...state,
      isLoading: false,
    };
    case ACCESS_CODE_CREATION_COMPLETED:
    return {
        ...state,
        isLoading: false,
    }; 
    case OPEN_ACCESS_CODE_DIALOG:
    return {
        ...state,
        isAccessCodeDialogOpen: true,
    }; 

    case CLOSE_ACCESS_CODE_DIALOG:
    return {
      ...state,
      isAccessCodeDialogOpen: false,
    };
    case LOAD_ACCESS_CODE_LOGIN_USERNAME_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        loginUserName: data,
      };
    }
    case LOAD_ACCESS_CODE_LOGIN_USERNAME_CLEAR: {
      return {
        ...state,
        loginUserName: '',
      };
    }
    default:
      return state;
  }
};
